import React, { useState, useEffect } from 'react';
import OwlCarousel from 'react-owl-carousel';

const Collaborators = () => {
  const collaboratorLogos = [
    '../assetsTemplates/template1/img/brand1.jpg',
    '../assetsTemplates/template1/img/brand2.jpg',
    '../assetsTemplates/template1/img/brand3.jpg',
    '../assetsTemplates/template1/img/brand4.jpg',
    '../assetsTemplates/template1/img/brand5.jpg',
    '../assetsTemplates/template1/img/brand6.jpg',
    '../assetsTemplates/template1/img/brand7.jpg',
    '../assetsTemplates/template1/img/brand8.jpg',
    '../assetsTemplates/template1/img/brand9.jpg',
    '../assetsTemplates/template1/img/brand10.jpg',
    '../assetsTemplates/template1/img/brand11.jpg',
    // Add more logo image paths here
  ];

  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className={`container-xxl py-5 wow fadeInUp${isLoaded ? '' : ' hidden'}`} data-wow-delay="0.1s">
      <div className="container">
        <div className="text-center">
          <h6 className="section-title bg-white text-center text-primary px-3">Partners</h6>
          <h1 className="mb-5">Our Partners</h1>
        </div>
        <OwlCarousel className="collaborators-carousel position-relative owl-theme" items={4} loop autoplay dots={true}>
          {collaboratorLogos.map((logoPath, index) => (
            <div className="collaborator-item text-center" key={index}>
              <img className="border p-2 mx-auto mb-3" src={logoPath} style={{ width: '150px', height: '150px' }} alt={`Collaborator Logo ${index + 1}`} />
            </div>
          ))}
        </OwlCarousel>
      </div>

      {/* Custom CSS styles */}
      <style>
        {`
          .collaborators-carousel .owl-nav .owl-prev,
          .collaborators-carousel .owl-nav .owl-next {
            background-color: #2196F3;
            color: #ffffff;
            font-size: 24px;
            border: none;
            border-radius: 50%;
            padding: 10px;
          }

          .collaborators-carousel .owl-nav .owl-prev {
            margin-right: 10px;
          }

          .collaborators-carousel .owl-nav .owl-next {
            margin-left: 10px;
          }

          .collaborators-carousel .owl-dots .owl-dot {
            background-color: #cccccc;
            width: 12px;
            height: 12px;
            margin: 5px;
            border-radius: 50%;
            border: 2px solid #ffffff;
          }

          .collaborators-carousel .owl-dots .owl-dot.active {
            background-color: #2196F3;
          }
        `}
      </style>
    </div>
  );
};

export default Collaborators;
